
import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

interface BookLoaderProps {
  className?: string;
}

export function BookLoader({ className }: BookLoaderProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center gap-2", className)}>
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}
